<form [formGroup]="form">
  <div class="gap-lg grid" formArrayName="aptitudes">
    @for (control of aptitudes.controls; track $index; let idx = $index) {
      <app-expansion-panel [titre]="'Aptitude ' + (idx + 1)" [item]="idx" [isOpen]="true" [actions]="aptitudeActions">
        <div class="m-lg">
          <div hlmField>
            <label [for]="'autocomplete-' + idx" hlmFieldLabel>Aptitude</label>
            <div type="autocomplete" hlmButtonGroup>
              <brn-select class="inline-block" (valueChange)="setReferentiel($event)">
                <hlm-select-trigger>
                  <hlm-select-value>
                    <div *brnSelectValue="let value">
                      {{ value?.nom ?? 'Tous les référentiels' }}
                    </div>
                  </hlm-select-value>
                </hlm-select-trigger>
                <hlm-select-content class="!min-w-max">
                  <hlm-option [value]="undefined">
                    <span>Tous les référentiels</span>
                  </hlm-option>
                  @for (referentiel of _referentiels(); track referentiel.id) {
                    <hlm-option [value]="referentiel">{{ referentiel.nom }}</hlm-option>
                  }
                </hlm-select-content>
              </brn-select>
              <hlm-autocomplete
                [id]="'autocomplete-' + idx"
                [filteredOptions]="aptitudesFiltrees()"
                [formControlName]="idx"
                (searchChange)="filterAptitudes($event)"
                autocompleteSearchClass="border-stroke-neutral-medium"
              />
            </div>
          </div>
        </div>
      </app-expansion-panel>
    }
    <app-button-add-new (click)="ajouterAptitude()" label="Ajouter une aptitude à l'étape" />
  </div>
</form>
